import { KYCRandomSecQuesAnsOption } from "./kycRandomSecQuesAnsOption";

export class SubmitSecurityQuestionRequestViewModel {
  RefNo: string;
  ScreeningId: string;
  SQType: string;
  securityQuestionsAns: KYCRandomSecQuesAnsOption[];
}
